import { takeLatest, put, all, call } from 'redux-saga/effects';

import NPAReportTypes from './npa-report.types';
import { getNPAReportDetails } from './npa-report.service';
import {
	fetchNPAReportSuccess,
	fetchNPAReportFailure,
	fetchNPAReportResponseResetChanged,
} from './npa-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START FETCH NPA DETAILS  ******************** */
export function* fetchNPAReportDetails({ payload }: any) {
	try {
		const key = 'GetNPAReportDetailsKey';
		const {
			companyID,
			databaseName,
			reportDate,
			branchID,
			groupID,
			centerID,
			funderID,
			memberID,
			setLoanType,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			ReportDate: reportDate,
			BranchID: branchID,
			GroupID: groupID,
			CenterID: centerID,
			FunderID: funderID,
			MemberID: memberID,
			UserLevel: memberID,
			LoanType: setLoanType,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getNPAReportDetails, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			yield put(fetchNPAReportFailure(responseData.data));
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchNPAReportFailure(responseData.data));
		} else {
			yield put(fetchNPAReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchNPAReportFailure(error));
	}
}

export function* resetNPAReportResponse() {
	yield put(fetchNPAReportResponseResetChanged());
}

export function* onFetchNPAReportDetails() {
	yield takeLatest(NPAReportTypes.FETCH_NPA_REPORT_START, fetchNPAReportDetails);
}

export function* onFetchNPAReportResponseReset() {
	yield takeLatest(NPAReportTypes.FETCH_NPA_REPORT_RESPONSE_RESET_START, resetNPAReportResponse);
}
/** *********************  END FETCH NPA DETAILS ******************** */
export function* NPAReportSaga() {
	yield all([call(onFetchNPAReportDetails), call(onFetchNPAReportResponseReset)]);
}
